import { actionableTaskPredicate, openTaskPredicate, reviewableTaskPredicate } from '../types/predicates';
import { IWorkflowInstance } from '../types/workflow-instance.interface';

export const getWorkflowOpenTasks = (workflowInstance: IWorkflowInstance, chimeraUserId?: string) => {
  return workflowInstance.task.filter(
    (task) => openTaskPredicate(task) && (actionableTaskPredicate(task) || reviewableTaskPredicate(task, chimeraUserId))
  );
};
